// Private saved-job references only. This does not create/save an engine brief,
// approve a source, generate an image or revive the public GPT bridge.
const binding=job=>JSON.stringify([job?.id,job?.artworkRevision,job?.artworkEngine?.revision??null,job?.artworkEngine?.specFingerprint??null])
const fail=message=>new Error(message)
// Route key changes include same-job steps, tabs and Back/Forward. Separate
// persisted-file readback from permission to continue work/change the view.
export function advancePrivateBezelNavigation(previous,key) {
  return previous.key===key?previous:{key,epoch:previous.epoch+1}
}
export function createPrivateBezelOperation(job,navigation,readCurrent) {
  const target=binding(job)
  const sameJob=()=>{const state=readCurrent();return state.active&&binding(state.job)===target}
  let cancelled=false
  return {sameJob,isCurrent:()=>{
    if(!sameJob()||readCurrent().navigation!==navigation)cancelled=true
    return !cancelled
  }}
}
export async function savePrivateBezelReferences({job,files,upload,onSaved=()=>{},isCurrent=()=>true,canReadback=isCurrent}) {
  if(!job?.id||!Number.isSafeInteger(job.version)||job.deletedAt||!Array.isArray(files)||!files.length||files.length>3)throw fail('Open a current saved artwork job before saving references.')
  const target=binding(job),saved=[];let current=job
  for(const file of files){
    if(!isCurrent()||binding(current)!==target)throw fail('The artwork job or revision changed. Saved references remain in their original job; nothing was retried.')
    const bytes=await file.arrayBuffer()
    const sha256=Array.from(new Uint8Array(await globalThis.crypto.subtle.digest('SHA-256',bytes)),n=>n.toString(16).padStart(2,'0')).join('')
    if(!isCurrent())throw fail('The selected job changed before upload. No next upload was started.')
    const result=await upload(current,'artwork_engine_reference',file)
    const next=result?.job,oldIds=new Set((current.assets||[]).map(a=>a.id))
    const added=(next?.assets||[]).filter(a=>!oldIds.has(a.id))
    const asset=added.length===1?added[0]:null
    if(!next||binding(next)!==target||next.version!==current.version+1||!asset?.id||asset.role!=='artwork_engine_reference'||asset.revision!==job.artworkRevision||asset.sha256!==sha256||asset.bytes!==bytes.byteLength)throw fail('Reference save could not be verified for this exact job/revision. Refresh Proof files to reconcile; do not retry automatically.')
    current=next;saved.push(asset)
    // Publish each confirmed save, so a later failure never hides partial work.
    if(canReadback())await onSaved(current,asset)
  }
  return {job:current,assets:saved}
}
